module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-oyster-fluted-balmoral-0.54e386f8.jpg";